import { Condition } from '@api/api/compass-schema';
import { CheckBox } from '@design/components/checkbox/CheckBox';

import { ConditionBuilder } from '../../custom-scenario-modal/ConditionBuilder';
import { MappedConditions } from '../use-scenario-assistant/enrichedConditions';
import { useScenarioAssistant } from '../use-scenario-assistant/useScenarioAssistant';
import styles from './ScenarioConditionBuilder.module.scss';

export interface ScenarioConditionBuilderProps {
  editFilterKey?: string;
  conditions: MappedConditions[];
}

export const ScenarioConditionBuilder = ({
  editFilterKey,
  conditions,
}: ScenarioConditionBuilderProps) => {
  const { updateCustomCondition, toggleConditionState } =
    useScenarioAssistant();

  const onConditionChange = (
    editedCondition: Partial<Condition>,
    condition: MappedConditions
  ) => {
    updateCustomCondition({
      ...condition,
      ...editedCondition,
    });
  };

  const filteredConditions = editFilterKey
    ? conditions.filter(c => c.id === editFilterKey)
    : conditions;

  return (
    <section
      className={styles.conditions}
      data-testid="scenario-condition-builder"
    >
      {filteredConditions.map(condition => (
        <div
          className={styles.conditionItem}
          data-testid="scenario-condition-item"
          key={condition.id}
        >
          {!editFilterKey && (
            <CheckBox
              name=""
              label=""
              data-testid="scenario-condition-check"
              checked={condition.active}
              onChange={() => {
                toggleConditionState?.(condition.id);
              }}
            />
          )}
          <ConditionBuilder
            snake={condition.snake}
            onConditionChange={change => onConditionChange(change, condition)}
            defaultCondition={condition}
          />
        </div>
      ))}
    </section>
  );
};
